import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useEffect, useState } from "react"

import { filtersSchema } from "@tfg/types/schemas/products"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useSearchParamsFilters } from "~/components/hooks/useSearchParamsFilters"
import { useProductsQuery } from "~/pages/Brand/Products/List/hooks.ts"
import { ProductsAGECTable } from "~/pages/Brand/Regulations/AGEC/ProductsAGECTable.tsx"

export const ProductsAGECWrapper = () => {
  const [filtersValue, setFiltersValue] = useSearchParamsFilters(filtersSchema)

  const [debouncedProduct] = useDebouncedValue<string | undefined>(
    filtersValue.search,
    600
  )
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProduct])

  const productsQuery = useProductsQuery({
    fetchDataOptions: pagination,
    filters: { ...filtersValue, search: debouncedProduct },
  })
  return (
    <Stack>
      <DataFetchWrapper query={productsQuery}>
        {({ data, isFetching }) => (
          <Stack>
            <ProductsAGECTable
              data={data}
              fetchDataOptions={pagination}
              setPagination={setPagination}
              filtersValue={filtersValue}
              setFiltersValue={setFiltersValue}
              isFetching={isFetching}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
